import { GADGET_COLOR_TYPE } from 'components/molecules/dialog/FpEditGadgetImageDialog/gadget-color';
import { LOCALE_TYPE } from 'locales/locale';
import {
  GadgetModel,
  GadgetCommonModelGadgetTypeCodeEnum,
  GadgetEditModel,
  LayoutEditResponse,
  ProjectResponseAllOfTemplateFragEnum,
  ProjectResponseAllOfAdminFragEnum,
  ProjectCommonModelProjectStatusCodeEnum,
  ProjectDetailResponse,
  InviteeModel,
  NewArrivalNotificationModel,
  NewArrivalNotificationModelReadContentTypeEnum,
  NewArrivalNotificationListResponse,
  RoleModel, MainMenuItemEditModel,
  CommonManagementNotRequiredFlag,
  MainMenuItemModel,
  SavedSearchCriteriaResponse,
  ExtensiveAttributeModel,
  ExtensiveAttributeValueType,
  CommonManagementFlag,
  AvailableFlag,
  ExtensiveAttributeModelValueEditAllowFlagEnum,
  SearchResultResponse,
  ContentTagViewPatternResponse,
  DownloadHistoryModel,
  FileDownloadUrlResponse,
} from 'types/entity';
import {
  CommonManagementFlagCommonManagementFlagEnum,
  DataRackListGetResponse,
  MyFavoritesResponseModel,
} from 'types/entity-ddms';
import { LayoutResponse } from 'types/entity/layout-response';
import { MainMenuItemCommonModelFileServiceLeftPainControlTypeEnum, MainMenuItemCommonModelMainMenuItemTypeCodeEnum } from 'types/entity/main-menu-item-common-model';
import { ProjectResponse } from 'types/entity/project-response';
import { LoginUser } from 'types/model/user';

export const initialGadgetValue: GadgetModel = {
  gadget_id: '',
  original_gadget_id: undefined,
  display_name: '',
  gadget_type_code: GadgetCommonModelGadgetTypeCodeEnum.Gt1,
  gadget_contents_id: '',
  background_color: GADGET_COLOR_TYPE.WHITE,
  background_image_url: '',
  x_coordinates: 0,
  y_coordinates: 0,
  width: 1,
  height: 1,
};

export const initialGadgetEditValue: GadgetEditModel = {
  gadget_id: '',
  original_gadget_id: undefined,
  display_name_ja: '',
  display_name_en: '',
  gadget_type_code: GadgetCommonModelGadgetTypeCodeEnum.Gt1,
  gadget_contents_id: '',
  background_color: GADGET_COLOR_TYPE.WHITE,
  background_image_url: '',
  x_coordinates: 0,
  y_coordinates: 0,
  width: 1,
  height: 1,
};

export const initialLayoutValue: LayoutResponse = {
  layout_id: '',
  layout_name: '',
  roles: [],
  gadget: [],
};

export const initialLayoutEditValue: LayoutEditResponse = {
  layout_id: '',
  layout_name_ja: '',
  layout_name_en: '',
  roles: [],
  gadget: [],
};

export const initialUserValue: LoginUser = {
  locale: LOCALE_TYPE.JA,
  preferred_username: '',
  name: '',
  given_name: '',
  family_name: '',
  xgrab_company_id: '',
  access_points: ['FILE_PORTAL'],
} as LoginUser;

export const initialProjectValue: ProjectResponse = {
  project_id: '',
  template_frag: ProjectResponseAllOfTemplateFragEnum.Project,
  admin_frag: ProjectResponseAllOfAdminFragEnum.Nonadmin,
  project_name: '',
  project_type_name: '',
  owner_company_name: '',
  branch_object_name: '',
  project_status_code: ProjectCommonModelProjectStatusCodeEnum.Ps90,
  project_status: '',
  started_on: null,
  ended_on: null,
  responsible_person_name: '',
  responsible_person_name_without_middle_name: '',
  service_project_statuses: [],
  service_project_policies: [],
};

export const initialProjectDetailValue: ProjectDetailResponse = {
  owner_company_name: '',
  branch_object_name: '',
  business_type_name: '',
  project_group_name: '',
  area: '',
  project_group_status: '',
  project_group_completed_on: '',
  project_name: '',
  project_type_name: '',
  project_status: '',
  started_on: '',
  ended_on: '',
  responsible_person_name: '',
  responsible_person_name_without_middle_name: '',
  address: '',
  construction_place_address: '',
  tel_number: '',
  fax_number: '',
};

export const initialMyShortcutValue: MyFavoritesResponseModel = {
  common_management_flag: CommonManagementFlagCommonManagementFlagEnum.User,
  content_tag_id: '',
  data_rack_id: '',
  display_order: '',
  favorite_code: '',
  favorite_name: '',
  target_type: undefined,
  view_code: '',
};

export const initialInviteesValue: InviteeModel[] = [
  {
    user_name: '',
    user_name_without_middle_name: '',
    user_name_kana: '',
    user_name_kana_without_middle_name: '',
    mail_address: '',
  },
];

export const initialNewArrivalNotificationValue: NewArrivalNotificationModel = {
  new_arrival_notification_id: '',
  content_tag_id: '',
  content_tag_name: '',
  data_rack_id: '',
  data_rack_name: '',
  notification_content_type: '',
  notification_content: '',
  read_content_type: NewArrivalNotificationModelReadContentTypeEnum.Unread,
  updated_at: '',
  source_user_name_without_middle_name: '',
  source_xgrab_user_company_name: '',
  file_extension: '',
  downloadable_flag: false,
  highlight_flag: false,
};

export const initialNewArrivalNotificationListData: NewArrivalNotificationModel[] = [];

export const initialNewArrivalNotificationListResponseValue: NewArrivalNotificationListResponse = {
  api_display_values: [],
  offset: 0,
  additional_search_flag: false,
};

export const initialRoleValue: RoleModel = {
  role_code: '',
  role_name: '',
};

export const initialMainMenuItemEditValue: MainMenuItemEditModel = {
  main_menu_item_id: '',
  main_menu_item_type_code: MainMenuItemCommonModelMainMenuItemTypeCodeEnum.Mt6,
  main_menu_id: '',
  display_order: 0,
  content_tag_id: '',
  dc_management_code: '',
  common_management_flag: CommonManagementNotRequiredFlag.Blank,
  view_code: '',
  data_rack_id: '',
  search_criteria_id: '',
  url: '',
  display_name_ja: '',
  display_name_en: '',
  file_service_left_pain_control_type: MainMenuItemCommonModelFileServiceLeftPainControlTypeEnum.Close,
};

export const initialMainMenuItemValue: MainMenuItemModel = {
  main_menu_item_id: '',
  main_menu_item_type_code: MainMenuItemCommonModelMainMenuItemTypeCodeEnum.Mt6,
  main_menu_id: '',
  display_order: 0,
  content_tag_id: '',
  dc_management_code: '',
  common_management_flag: CommonManagementNotRequiredFlag.Blank,
  view_code: '',
  data_rack_id: '',
  search_criteria_id: '',
  url: '',
  display_name: '',
  file_service_left_pain_control_type: MainMenuItemCommonModelFileServiceLeftPainControlTypeEnum.Close,
};

export const initialSavedSearchCriteriaValue: SavedSearchCriteriaResponse = {
  used_layout_ids: [],
  search_criteria_id: '',
  display_name_ja: '',
  display_name_en: '',
  common_data_rack_extensive_attribute: [],
  user_data_rack_extensive_attribute: [],
  data_rack_name: '',
  create_user_name: '',
  created_at_from: '',
  created_at_to: '',
};

export const initialExtensiveAttributeValue: ExtensiveAttributeModel = {
  extensive_attribute_definition_id: '',
  extensive_attribute_definition_name: '',
  value_type: ExtensiveAttributeValueType.Text,
  common_management_flag: CommonManagementFlag.User,
  available_flag: AvailableFlag.Available,
  value_edit_allow_flag: ExtensiveAttributeModelValueEditAllowFlagEnum.Allow,
  extensive_attribute_value: [],
  content_tags: [],
};

export const initialSearchResultResponse: SearchResultResponse = {
  data_rack_id: '',
  content_tag_id: '',
  data_rack_name: '',
  sequence_number: 0,
  data_item_count: 0,
  create_company_name: '',
  create_user_name: '',
  create_user_name_without_middle_name: '',
  created_at: '',
  update_company_name: '',
  update_user_name: '',
  update_user_name_without_middle_name: '',
  updated_at: '',
  content_tag_name: '',
  data_rack_extensive_attribute_definition: [],
  file_extension: '',
};

export const initialViewPatternValue: ContentTagViewPatternResponse = {
  project_id: '',
  content_tag_id: '',
  dc_management_code: '',
  view_code: '',
  view_name: '',
};

export const initialDownloadHistoryValue: DownloadHistoryModel = {
  create_company_name: '',
  create_user_name: '',
  create_user_name_without_middle_name: '',
  created_at: '',
  content_tag_id: '',
  content_tag_name: '',
  file_extension: '',
  data_rack_id: '',
  data_rack_name: '',
  download_at: '',
};

export const initialFileDownloadUrlResponseValue: FileDownloadUrlResponse = {
  files: [],
};

export const initialDataRackListGetResponseValue: DataRackListGetResponse = {
  data_racks: [],
};
